import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import styles from "./scheduleEkyc.module.scss";
import Datepicker from "components/minor/date-picker/date-picker";

// ✅ Validation Schema
const validationSchema = Yup.object({
  topic: Yup.string().required("Topic is required"),
  date: Yup.string().required("Date is required"),
  start_time: Yup.string().required("Start time is required"),
  durationHr: Yup.string().required("Hour required"),
  durationMin: Yup.string().required("Minute required"),
  timezone: Yup.string().required("Timezone is required"),
  registration: Yup.boolean(),
});

const generateTimeOptions = () => {
  const times = [];
  let start = new Date();
  start.setHours(9, 0, 0, 0);
  const end = new Date();
  end.setHours(23, 0, 0, 0);

  while (start <= end) {
    const value = start.toTimeString().slice(0, 5); // "HH:MM"
    const label = start.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    times.push({ value, label });
    start.setMinutes(start.getMinutes() + 15);
  }
  return times;
};

const timeOptions = generateTimeOptions();
const ScheduleEkyc = ({ handleClose,handleSubmit }) => {
  return (
    <Formik
      initialValues={{
        topic: "",
        end_time: "",
        date:"",
        start_time: timeOptions[0].value,
        durationHr: "1",
        durationMin: "0",
        timezone: "(GMT + 530) India",
        registration: false,
      }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        console.log("Form Submitted:", values);
        handleSubmit({ ...values });
      }}
    >
      {({ values,touched,errors,setFieldValue }) => (
        <Form className={styles.ScheduledMeetingForm}>
          <h3>Schedule eKYC</h3>
          <div className={styles.formCont}>
            {/* Topic */}
            <div className={styles.fromRow}>
              <label>Topic</label>
              <div className={styles.inlineFormFields} style={{flexDirection:"column", alignItems:'flex-start'}}>
                <Field type="text" name="topic" className={styles.fluid} />
                    {touched.topic && errors.topic && (
                    <div className={styles.error}>{errors.topic}</div>
                  )}
              </div>
          
            </div>

<div className={styles.fromRow}>
              <label>Start Time</label>
               <div className={styles.inlineFormFieldsWrapper}>
              <div className={styles.inlineFormFields}>
                 <Datepicker  name="date" label="Date" value={values.date || ''}
                                   onChange={(newValue) => setFieldValue("date", newValue)} />
                {/* <Field type="date" name="date" /> */}
                       <Field
                    as="select"
                    name="start_time"
                  onChange={(e) => {
                      const val = e.target.value;
                      setFieldValue("start_time", val);
                    }}
                  >
                 
                    {timeOptions.map((t) => (
                      <option key={t.value} value={t.value}>
                        {t.label}
                      </option>
                    ))}
                  </Field>
                {/* <Field as="select" name="period">
                  <option>AM</option>
                  <option>PM</option>
                </Field> */}
              </div>
              {touched.date && errors.date && (
                  <div className={styles.error} style={{marginTop:'10px'}}>{errors.date}</div>
                )}
                </div>
            </div>
            {/* Duration */}
            <div className={styles.fromRow}>
              <label>Duration</label>
              <div className={styles.inlineFormFields}>
                <Field as="select" name="durationHr" className={styles.w100}>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                </Field>
                <p>hr</p>
                <Field as="select" name="durationMin" className={styles.w100}>
                  <option>0</option>
                  <option>15</option>
                  <option>30</option>
                  <option>45</option>
                </Field>
                <p>min</p>
              </div>
            </div>

            {/* Timezone */}
            <div className={styles.fromRow}>
              <label>Time Zone</label>
              <div className={styles.inlineFormFields}>
                <Field as="select" name="timezone" className={styles.fluid}>
                  <option>(GMT + 530) India</option>
                </Field>
              </div>
            </div>

            {/* Registration */}
            <div className={`${styles.fromRow} ${styles.fDirection}`}>
              <label>Registration</label>
              <div className={styles.inlineFormFields}>
                <Field type="checkbox" name="registration" />
                Required
              </div>
            </div>

            {/* Buttons */}
            <div className={styles.btnContainer}>
              <button
                type="button"
                onClick={handleClose}
                className={styles.btnBordered}
              >
                Cancel
              </button>
              <button type="submit" className={styles.btnPrimary}>
                Save
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default ScheduleEkyc;
